import { Injectable } from '@angular/core'
import { Observable, of, throwError } from 'rxjs'
import { retry, tap } from 'rxjs/operators'

interface AdobeLaunch {
  initializePage(page: any, environment: string): void
}

interface DataLayerEvent {
  [key: string]: any
  event: string
}

declare global {
  interface Window {
    adobeLaunch: AdobeLaunch
    dataLayer: DataLayerEvent[]
  }
}

@Injectable({
  providedIn: 'root',
})
export class AdobeLaunchService {
  /* istanbul ignore next */
  private getAdobeLaunch(): Observable<AdobeLaunch> {
    if (typeof window === 'undefined') {
      return of({
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        initializePage() {},
      })
    }
    if (window['adobeLaunch']) {
      return of(window['adobeLaunch'])
    }
    return throwError('AdobeLaunch Undefined')
  }
  /* istanbul ignore next */
  private adobeLaunch(): Observable<AdobeLaunch> {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return this.getAdobeLaunch().pipe(retry(3))
  }
  /* istanbul ignore next */
  public initializePage(page: any, environment: string) {
    this.adobeLaunch()
      .pipe(tap((al) => al.initializePage(page, environment)))
      .subscribe()
  }

  public callToAction(
    callToAction: string,
    callToActionLocation: string,
    callToActionType: string,
  ) {
    try {
      window['dataLayer'] = window['dataLayer'] || []
      window['dataLayer'].push({
        event: 'callToAction',
        callToAction: {
          location: callToActionLocation,
          ctaName: callToAction,
          ctaType: callToActionType,
        },
        fireTrackLink: {
          fireTrackLink: 'true',
        },
      })
    } catch (e) {
      console.log(
        'Cannot trigger Adobe Launch tracking locally, need to run in prod mode',
      )
    }
  }

  public touchPoint(
    touchPointPageTicker: string,
    touchPointType: string,
    type: string,
    transact: string,
  ) {
    try {
      window['dataLayer'] = window['dataLayer'] || []
      window['dataLayer'].push({
        event: 'touchPoint',
        touchPoint: {
          touchPoint: [
            touchPointPageTicker,
            type,
            touchPointType,
            transact,
          ].join(':'),
        },
        fireTrackLink: {
          fireTrackLink: 'true',
        },
      })
    } catch (e) {
      console.log(
        'Cannot trigger Adobe Launch tracking locally, need to run in prod mode',
      )
    }
  }

  public mediaEvent(event, mediaId) {
    try {
      window['dataLayer'] = window['dataLayer'] || []
      window['dataLayer'].push({
        event: event,
        media: {
          mediaName: mediaId,
        },
      })
    } catch (e) {
      console.log(
        'Cannot trigger Adobe Launch tracking locally, need to run in prod mode',
      )
    }
  }
  public subPageTabEvent(subPageID) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'subPageViewed', //e166
      subPage: {
        subPageID: subPageID, //v105
        spClicked: 'true',
      },
    })
  }
}
